export const userGraphqlSchema = `
    id
    email
    document_type
    identity_number
    first_name
    surname
    second_surname
    phone
    address
    birth_date
    region
    commune
    client_points
`;